export enum WarehouseRestockListItemAction {
  Approve,
  Edit,
  More,
  Preview,
  Reject,
  Remove,
}
